import debugFactory from 'debug';
import { keepalive } from '../rest/securityAccessRest';
import store from '../store/store';
import { displayMessage, WARNING } from '../components/message/messageDucks';
import { loadDocuments } from '../../documents/documentsDucks';
import { loadNews } from '../../news/newsDucks';
import { APP_OFFLINE, APP_ONLINE } from '../initializers/initDucks';
import initExternalDependencies from '../config/initExternalDependencies';
import { loadRoadmap } from '../../roadmap/roadmapDucks';
import { loadLinks } from '../../links/linksDucks';

const debug = debugFactory('offlineManager');

export const isOnline = () => (navigator.onLine);

export default () => {
  const { dispatch } = store;

  window.addEventListener('offline', () => {
    debug('App is offline');
    dispatch({ type: APP_OFFLINE });
    dispatch(displayMessage(
      'ic-ondes',
      'Vous n\'êtes pas connecté à Internet. Connectez-vous pour mettre à jour le book de visite.',
      WARNING,
    ));
  }, false);

  window.addEventListener('online', () => {
    keepalive();
    initExternalDependencies();
    dispatch({ type: APP_ONLINE });
    dispatch(displayMessage(
      'ic-ondes',
      'Vous êtes à nouveau connecté. Le book va se mettre à jour',
      WARNING,
    ));
    dispatch(loadDocuments());
    dispatch(loadNews());
    dispatch(loadRoadmap());
    dispatch(loadLinks());
    debug('App is online');
  }, false);
};



// WEBPACK FOOTER //
// ./book/src/commons/offline/offlineManager.js